import { useTranslation } from "react-i18next";

export const NotFoundPage = () => {

    const [t] = useTranslation("common");

    return <>{t("general.notFound")}</>
}